import React from "react";
import Section from "../../../components/layout/marketing/Section";
import { Button } from "../../../components/common/button";
import { buildPortalUrl } from "../../../utils/url";

export default function FinalCTASection() {
    const handleCTAClick = () => {
        const url = buildPortalUrl({ mode: "register", content: "final_cta_setup" });
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return (
        <Section className="relative bg-bg-subtle" id="contact">
            {/* Content */}
            <div className="relative z-10 flex justify-center">
                <div className="w-full max-w-4xl rounded-2xl bg-white px-8 py-14  text-center shadow-xl sm:px-12">
                    <h2 className="md:text-4xl text-3xl font-semibold text-text-primary sm:text-3xl">
                        Get started in minutes{" "}
                        <span className="bg-brand-gradient bg-clip-text text-transparent">not months</span>
                    </h2>

                    <p className="mx-auto mt-3 max-w-xl text-lg md:text-xl text-text-muted sm:text-base">
                        Create your personalized WhatsApp assistant and clinic webpage — ready in minutes.
                    </p>

                    <div className="mt-6 flex justify-center">
                        <Button variant="primaryGlow" size="md" onClick={handleCTAClick}>
                            Start my Free Setup
                        </Button>
                    </div>
                </div>
            </div>
        </Section>
    );
}
